module.exports = __webpack_public_path__ + "static/img/av2.cd216372.png";